import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=352bdd8e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=352bdd8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bdd8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352bdd8e')) {
      api.createRecord('352bdd8e', component.options)
    } else {
      api.reload('352bdd8e', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=352bdd8e&scoped=true", function () {
      api.rerender('352bdd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/Footer.vue"
export default component.exports